import NextImage from 'next/image';

import useTranslation from 'shared/hooks/useTranslation';

import { Typography } from '@/ui/shared/molecules/Typography/Typography';

import { NavLink } from '../../NavLink/NavLink';
import styles from './LinkInExpandedMenuMobile.module.scss';
import * as types from './LinkInExpandedMenuMobile.type';

export function LinkInExpandedMenuMobile({ item }: types.LinkInExpandedMenuMobile) {
  const { t } = useTranslation('common');

  return (
    <li className={styles.listItem} key={item.id}>
      <NextImage src={`/img/temporary-menu-icons/${item.icon}.svg`} alt={item.name} width={20} height={20} />
      <NavLink aTag={item?.aTag} href={item.link} passHref activeMenu bold>
        <Typography.Paragraph color="#fff" size="xl" tagType="span" gutterBottom={false}>
          {item.name.includes('.') ? t(`navbar.${item.name}`) : item.name}
        </Typography.Paragraph>
      </NavLink>
    </li>
  );
}
